<template>
  <div :class="['container-2', `property-1-${property1}`, className]">
    <div class="frame-37">
      <img class="handshake" alt="Handshake" :src="handshake" />

      <div class="frame-38">
        <div class="text-wrapper-20">Fidélité client renforcée</div>

        <p class="text-wrapper-21">
          Mettez en place des programmes de fidélité personnalisés pour
          transformer vos clients en ambassadeurs.
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "Container2",
  props: {
    property1: {
      type: String,
      required: true,
    },
    className: {
      type: String,
      default: "",
    },
    handshake: {
      type: String,
      default: "https://c.animaapp.com/nNxA75tB/img/handshake-1.svg",
    },
  },
});
</script>

<style>
.container-2 {
  align-items: center;
  background-color: #d2f1ba;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: auto;
  justify-content: center;
  left: unset;
  max-width: none;
  min-height: 212px;
  padding: 30px;
  position: relative;
  width: 100%;
}

.container-2 .frame-37 {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 18px;
  position: relative;
  width: 100%;
}

.container-2 .handshake {
  height: 32px;
  position: relative;
  width: 32px;
}

.container-2 .frame-38 {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 14px;
  position: relative;
  width: 100%;
}

.container-2 .text-wrapper-20 {
  align-self: stretch;
  color: #1a1a1a;
  font-family: "Montserrat", Helvetica;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 28px;
  margin-top: -1.00px;
  position: relative;
}

.container-2 .text-wrapper-21 {
  align-self: stretch;
  color: #313131;
  font-family: "Open Sans", Helvetica;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 20px;
  position: relative;
  text-align: center;
}

.container-2.property-1-default {
  border: 0px none;
  box-shadow: 0px 0px 0px transparent, 0px 1px 2px #0000000d;
  top: unset;
}

.container-2.property-1-variant-2 {
  border: 1px solid;
  border-color: #c7e7af;
  box-shadow: 0px 1px 6px #08473440;
  top: unset;
}

@media (max-width: 768px) {
  .container-2 {
    min-height: 0;
    padding: 20px 16px;
  }
}
</style>
